import { render, staticRenderFns } from "./InfogandeSortering.vue?vue&type=template&id=2d276d30&scoped=true&"
import script from "./InfogandeSortering.vue?vue&type=script&lang=js&"
export * from "./InfogandeSortering.vue?vue&type=script&lang=js&"
import style0 from "./InfogandeSortering.vue?vue&type=style&index=0&id=2d276d30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d276d30",
  null
  
)

export default component.exports